import { render } from "./LifeStylePage.vue?vue&type=template&id=185f373d&scoped=true"
import script from "./LifeStylePage.vue?vue&type=script&lang=js"
export * from "./LifeStylePage.vue?vue&type=script&lang=js"

import "./LifeStylePage.vue?vue&type=style&index=0&id=185f373d&lang=scss"
import "./LifeStylePage.vue?vue&type=style&index=1&id=185f373d&lang=scss&scoped=true"
import "./LifeStylePage.vue?vue&type=style&index=2&id=185f373d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185f373d"]])

export default __exports__